import type { ConsentCompletionReturnMode } from './completePage.types';

export type ConsentEntryMode = 'list' | 'direct' | 'notice';

export const CONSENT_ENTRY_QUERY_KEY = 'entry';

export function resolveConsentEntryMode(
  entry: string | null | undefined,
): ConsentEntryMode {
  if (entry === 'notice') return 'notice';
  return entry === 'list' ? 'list' : 'direct';
}

export function resolveConsentCompletionReturnMode(
  entry: string | null | undefined,
): ConsentCompletionReturnMode {
  return resolveConsentEntryMode(entry) === 'list' ? 'home' : 'close';
}

export function shouldReplaceConsentCompletionHistory(
  entry: string | null | undefined,
): boolean {
  return resolveConsentEntryMode(entry) !== 'list';
}

export function resolveConsentCloseHistoryDelta(
  entry: string | null | undefined,
): number {
  const entryMode = resolveConsentEntryMode(entry);
  if (entryMode === 'notice') return 2;
  if (entryMode === 'direct') return 1;
  return 0;
}

export function appendConsentEntryMode(
  projectId: string,
  entryMode: ConsentEntryMode,
): string {
  const params = new URLSearchParams({
    projectId,
    [CONSENT_ENTRY_QUERY_KEY]: entryMode,
  });

  return params.toString();
}
